// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + (chunkId === 179 ? "main" : chunkId) + "." + {"94":"9810cff2","179":"c7634d27","497":"32892da5","662":"6b5a1236"}[chunkId] + ".css";
};